import {
  Button,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Table,
  Container,
  Row,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { useEffect, useState, useMemo } from "react";
import Header from "components/Headers/Header.js";
import Loader from "components/Loader.js"; // ✅ Import do Loader
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const TableCopy = () => {
  const [copies, setCopies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ Loader
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [currentCopy, setCurrentCopy] = useState(null);
  const [newCopy, setNewCopy] = useState({
    titulo: "",
    copy: "",
    imagem: "",
    countryId: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [copiesPerPage] = useState(20);
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [copiesRes, countriesRes] = await Promise.all([
          axios.get(`${API_URL}/copies`),
          axios.get(`${API_URL}/countries`),
        ]);
        setCopies(copiesRes.data);
        setCountries(countriesRes.data);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false); // ✅ Desliga o loader
      }
    };

    fetchData();
  }, []);

  const toggleModal = () => setModalOpen(!modalOpen);
  const toggleEditModal = () => setEditModalOpen(!editModalOpen);

  const handleCreateCopy = async () => {
    try {
      const response = await axios.post(`${API_URL}/copies`, newCopy);
      setCopies([...copies, response.data.copy]);
      setNewCopy({ titulo: "", copy: "", imagem: "", countryId: "" });
      toggleModal();
    } catch (error) {
      console.error("Erro ao criar cópia:", error);
    }
  };

  const handleEditCopy = async () => {
    if (!currentCopy) return;
    try {
      const response = await axios.put(`${API_URL}/copies/${currentCopy.id}`, currentCopy);
      setCopies(copies.map((c) => (c.id === currentCopy.id ? response.data.copy : c)));
      toggleEditModal();
    } catch (error) {
      console.error("Erro ao atualizar cópia:", error);
    }
  };

  const handleDeleteCopy = async (id) => {
    try {
      await axios.delete(`${API_URL}/copies/${id}`);
      setCopies(copies.filter((copy) => copy.id !== id));
    } catch (error) {
      console.error("Erro ao deletar cópia:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCopy({ ...newCopy, [name]: value });
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentCopy({ ...currentCopy, [name]: value });
  };

  // Ordenação
  const sortedCopies = useMemo(() => {
    return [...copies].sort((a, b) => {
      const countryA = a.Country?.name?.toLowerCase() || "";
      const countryB = b.Country?.name?.toLowerCase() || "";
      return sortOrder === "asc" ? countryA.localeCompare(countryB) : countryB.localeCompare(countryA);
    });
  }, [copies, sortOrder]);

  // Paginação
  const indexOfLastCopy = currentPage * copiesPerPage;
  const indexOfFirstCopy = indexOfLastCopy - copiesPerPage;
  const currentCopies = sortedCopies.slice(indexOfFirstCopy, indexOfLastCopy);
  const totalPages = Math.ceil(sortedCopies.length / copiesPerPage);

  // ✅ Exibe Loader enquanto carrega
  if (loading) {
    return (
      <>
        <Header />
        <Loader />
      </>
    );
  }

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Lista de Cópias</h3>
                <Button color="primary" onClick={toggleModal}>
                  Adicionar Nova Cópia
                </Button>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th
                      scope="col"
                      style={{ cursor: "pointer" }}
                      onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
                    >
                      País {sortOrder === "asc" ? "▲" : "▼"}
                    </th>
                    <th scope="col">Título</th>
                    <th scope="col">Copy</th>
                    <th scope="col">Imagem</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {currentCopies.map((copy) => (
                    <tr key={copy.id}>
                      <td>{copy.Country ? `${copy.Country.name} (${copy.Country.code})` : "-"}</td>
                      <th scope="row">
                        <Media className="align-items-center">
                          <span className="mb-0 text-sm">{copy.titulo}</span>
                        </Media>
                      </th>
                      <td
                        style={{
                          maxWidth: "300px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {copy.copy}
                      </td>
                      <td>
                        {copy.imagem ? (
                          <img
                            src={copy.imagem}
                            alt={copy.titulo}
                            style={{
                              maxWidth: "60px",
                              maxHeight: "60px",
                              objectFit: "contain",
                              borderRadius: "5px",
                            }}
                          />
                        ) : (
                          "Sem Imagem"
                        )}
                      </td>
                      <td className="text-right">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn-icon-only text-light"
                            href="#pablo"
                            role="button"
                            size="sm"
                            color=""
                            onClick={(e) => e.preventDefault()}
                          >
                            <i className="fas fa-ellipsis-v" />
                          </DropdownToggle>
                          <DropdownMenu container="body" className="dropdown-menu-arrow" right>
                            <DropdownItem
                              onClick={() => {
                                setCurrentCopy({
                                  ...copy,
                                  countryId: copy.countryId || copy.Country?.id,
                                });
                                toggleEditModal();
                              }}
                            >
                              Editar
                            </DropdownItem>
                            <DropdownItem onClick={() => handleDeleteCopy(copy.id)}>
                              Deletar
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* Paginação */}
              <CardFooter className="py-4">
                <Pagination className="pagination justify-content-end mb-0">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink onClick={() => setCurrentPage(currentPage - 1)}>
                      <i className="fas fa-angle-left" />
                    </PaginationLink>
                  </PaginationItem>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <PaginationItem key={page} active={page === currentPage}>
                      <PaginationLink onClick={() => setCurrentPage(page)}>{page}</PaginationLink>
                    </PaginationItem>
                  ))}
                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink onClick={() => setCurrentPage(currentPage + 1)}>
                      <i className="fas fa-angle-right" />
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
      {/* Modal de criação */}
      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <div className="modal-header">
          <h5 className="modal-title">Adicionar Nova Cópia</h5>
          <button className="close" type="button" onClick={toggleModal}>
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="titulo">Título</Label>
              <Input type="text" id="titulo" name="titulo" value={newCopy.titulo} onChange={handleInputChange} />
            </FormGroup>
            <FormGroup>
              <Label for="copy">Copy</Label>
              <Input type="textarea" id="copy" name="copy" value={newCopy.copy} onChange={handleInputChange} />
            </FormGroup>
            <FormGroup>
              <Label for="imagem">Imagem (URL)</Label>
              <Input type="text" id="imagem" name="imagem" value={newCopy.imagem} onChange={handleInputChange} />
            </FormGroup>
            <FormGroup>
              <Label for="countryId">País</Label>
              <Input type="select" id="countryId" name="countryId" value={newCopy.countryId} onChange={handleInputChange}>
                <option value="">Nenhum país</option>
                {countries.map((country) => (
                  <option key={country.id} value={country.id}>{country.name} ({country.code})</option>
                ))}
              </Input>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleCreateCopy}>Criar Cópia</Button>
          <Button color="secondary" onClick={toggleModal}>Cancelar</Button>
        </ModalFooter>
      </Modal>

      {currentCopy && (
        <Modal isOpen={editModalOpen} toggle={toggleEditModal}>
          <div className="modal-header">
            <h5 className="modal-title">Editar Cópia</h5>
            <button className="close" type="button" onClick={toggleEditModal}>
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="titulo">Título</Label>
                <Input type="text" id="titulo" name="titulo" value={currentCopy.titulo} onChange={handleEditInputChange} />
              </FormGroup>
              <FormGroup>
                <Label for="copy">Copy</Label>
                <Input type="textarea" id="copy" name="copy" value={currentCopy.copy} onChange={handleEditInputChange} />
              </FormGroup>
              <FormGroup>
                <Label for="imagem">Imagem (URL)</Label>
                <Input type="text" id="imagem" name="imagem" value={currentCopy.imagem || ""} onChange={handleEditInputChange} />
              </FormGroup>
              <FormGroup>
                <Label for="countryId">País</Label>
                <Input type="select" id="countryId" name="countryId" value={currentCopy.countryId || ""} onChange={handleEditInputChange}>
                  <option value="">Nenhum país</option>
                  {countries.map((country) => (
                    <option key={country.id} value={country.id}>{country.name} ({country.code})</option>
                  ))}
                </Input>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleEditCopy}>Salvar Alterações</Button>
            <Button color="secondary" onClick={toggleEditModal}>Cancelar</Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default TableCopy;